<div class="choices">
    <div routerLink="/videos/youtube" routerLinkActive="active" class="choice">Principale</div>
    <div routerLink="/videos/replays" routerLinkActive="active" class="choice">VOD</div>
    <div routerLink="/videos/shorts" routerLinkActive="active" class="choice">Shorts</div>
</div>

<router-outlet></router-outlet>
